import { IInvalidRow } from '@nkr/models/index';
import { Table, Col, Panel, Row, Button } from 'react-bootstrap';

interface IProps {
    data: IInvalidRow[],
    onChangeColumnMapping: () => void
}

const InvalidRows = (props: IProps) => {
    return (
        <Panel bsStyle='danger' defaultExpanded>
            <Panel.Heading>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        Invalid Rows in File
                    </div>

                    <Button style={{ marginRight: 5 }} onClick={props.onChangeColumnMapping}>Redo Column Mapping</Button>
                </div>
            </Panel.Heading>
            <Panel.Body collapsible>
                <div style={{ marginBottom: 10 }}>The following rows are invalid...</div>

                <Table condensed striped>
                    <thead>
                        <tr>
                            <th>Row #</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.data.map((item, invalidIndex) => (
                            <tr key={'invalid-row-' + invalidIndex}>
                                <td>{item.rowIndex}</td>
                                <td>
                                    {item.messages.map((message, index) =>
                                        <div key={'invalid-row-' + invalidIndex + '-msg-' + index}>{message}</div>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Panel.Body>
        </Panel>
    );
}

export default InvalidRows;